// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H5aX","footer":"styles_footer__3yJ4i","passCodeTooltip":"styles_passCodeTooltip__Nq0hy"};